<template>
  <div
    class="alert-info"
    data-qa="alert-info-banner"
    :class="colors.background"
  >
    <slot />
    <span
      class="alert-info__icon ui-icon-circle-info"
      :class="colors.icon"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  type?: 'primary' | 'warning'
}>(), {
  type: 'primary',
})

const colors = {
  icon: `${props.type}-icon`,
  background: `${props.type}-background`,
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.alert-info {
  padding: 16px;
  position: relative;
  overflow: hidden;
  border-radius: $border-radius-sm;

  &__icon {
    opacity: 1;
    position: absolute;
    bottom: -15px;
    right: -17px;
    font-size: 64px;
  }
}

.primary-icon {
  color: rgba($ui-kit-primary, 0.2);
}

.primary-background {
  background-color: $ui-kit-bg-secondary;
}

.warning-icon {
  color: rgba($ui-kit-text-warning, 0.2);
}

.warning-background {
  background-color: $ui-kit-bg-warning;
}
</style>
